// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-4228f4be]{min-height:300px;justify-content:center;align-items:center}progress-ring .ring[data-v-4228f4be]{stroke:#000!important}", ""]);
// Exports
module.exports = exports;
